import { render, staticRenderFns } from "./PlayerDetails.vue?vue&type=template&id=dcadc838&"
import script from "./PlayerDetails.vue?vue&type=script&lang=js&"
export * from "./PlayerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports